import { ImageCarousel, PNGS, SVGS } from '@zonofi/gandalf-components';
import React, { useState } from 'react';
import './signup-launch-screen.scss';
import ZoButton from '@zonofi/zo-components/input/zo-button/zo-button';
import { getConfigValue } from '@zonofi/common';
import {
  finService,
  getRefreshToken,
  getToken,
  TrackEventType,
  useAppSelector,
} from '@zonofi/seller-rtk-store';

export const SignupLaunchScreen: React.FC = () => {
  const encodedData = localStorage.getItem('authData');
  const baseUrl = getConfigValue('APP_ENDPOINT');
  const whatsappText = 'Hi ZöTok team, I need help activating my account.';

  const [copied, setCopied] = useState<boolean>(false);
  const token = useAppSelector(getToken);
  const refreshToken = useAppSelector(getRefreshToken);

  const decodedData = atob(encodedData);
  const decodedDataObj = JSON.parse(decodedData);
  decodedDataObj.token = token;
  decodedDataObj.refreshToken = refreshToken;
  decodedDataObj.userRoles = ['adm'];
  const newEncodedData = btoa(JSON.stringify(decodedDataObj));

  const handleCopy = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    try {
      await navigator.clipboard.writeText(
        `${baseUrl}/login?data=${newEncodedData}`
      );
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    } catch (error) {
      console.error('Error copying text:', error);
      alert('Failed to copy link. Please try manually copying it.');
    }
  };

  const handleShare = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (navigator.share) {
      try {
        await navigator.share({
          title: 'ZoTok App Link',
          text: 'Please open this link on a desktop browser to continue with WABA setup',
          url: `${baseUrl}/login?data=${newEncodedData}`,
        });
      } catch (error) {
        console.error('Error sharing:', error);
      }
    } else {
      alert(
        'Share functionality is not supported in this browser. You can copy the link manually.'
      );
    }
  };

  const openOnWhatsapp = () => {
    finService.trackEvent(TrackEventType.SIGNUP_SIMULATOR_SEND_ON_WHATSAPP, {
      whatsappText: whatsappText,
    });
    const whatsappUrl = `https://wa.me/${919100886619}?text=${whatsappText}`;
    window.open(whatsappUrl, '_blank');
  };

  return (
    <div className="signup-launch-screen">
      <div className="signup-launch-screen-container">
        <div className="signup-launch-screen-header">
          <div className="signup-launch-screen-header-text">
            <span className="signup-launch-screen-header-text-sub primary-font-semibold">
              Almost There!
            </span>
            <span className="signup-launch-screen-header-text-main primary-font-bold">
              Switch to Desktop for Full Power
            </span>
          </div>
          <img
            src={SVGS.ZotokLogo}
            alt=""
            className="signup-launch-screen-header-icon"
            width={70}
          />
        </div>
        {/* <span className="signup-launch-screen-text primary-font-regular">
          This next step needs a larger screen (multi‑panel view). We’ll move
          your session and pick up exactly where you left off.
        </span> */}
        <ImageCarousel
          images={[
            PNGS.CampaignImage1,
            PNGS.CampaignImage2,
            PNGS.CampaignImage3,
            PNGS.CampaignImage4,
            PNGS.CampaignImage5,
          ]}
        />
        <div className="signup-launch-screen-link-section">
          <div className="signup-launch-screen-link-section-text">
            <span className="main-text primary-font-bold">
              Quick Setup (2 minutes)
            </span>
          </div>
          <div className="signup-launch-screen-link-section-body">
            <span className="signup-launch-screen-link-section-body-text primary-font-regular">
              <span className="primary-font-semibold highlight">Step 1: </span>
              Open this secure link on your laptop/ desktop:
            </span>
            <div className="signup-launch-screen-link-section-body-box primary-font-regular">
              <a
                href={`${baseUrl}/login?data=${newEncodedData}`}
                target="_blank"
                rel="noreferrer"
              >
                {`${baseUrl}/login`}
              </a>
              <div className="link-section-buttons">
                <img
                  src={copied ? SVGS.TickGreenIcon : SVGS.CopyBlueIcon}
                  alt=""
                  onClick={handleCopy}
                  width={20}
                  height={20}
                />
                <img src={SVGS.ShareBlueIcon} alt="" onClick={handleShare} />
              </div>
            </div>
            <span className="signup-launch-screen-link-section-body-text primary-font-regular">
              <span className="primary-font-semibold highlight">Step 2: </span>
              Login with your mobile number (same as registration)
            </span>
            <span className="signup-launch-screen-link-section-body-text primary-font-regular">
              <span className="primary-font-semibold highlight">Step 3: </span>
              Start selling!
            </span>
            {/* <div className="signup-launch-screen-link-section-body-buttons">
              <ZoButton
                label={`${copied ? 'Copied' : 'Copy Link'}`}
                onClick={handleCopy}
                startIcon={<img src={SVGS.CopyBlueIcon} alt="" />}
                className="link-btn"
              />
              <ZoButton
                label="Share Link"
                onClick={handleShare}
                startIcon={<img src={SVGS.ShareBlueIcon} alt="" />}
                className="link-btn"
              />
            </div> */}
          </div>
        </div>
        <div className="signup-launch-screen-whatsapp-section">
          <div className="signup-launch-screen-whatsapp-section-text">
            <span className="main-text primary-font-bold">
              Need a guided walkthrough? Chat with us on WhatsApp.
            </span>
            <span className="sub-text primary-font-regular">
              Click{' '}
              <span className="highlight primary-font-semibold">
                Send on WhatsApp
              </span>{' '}
              and we’ll open WhatsApp with the prefilled text below.
            </span>
          </div>
          <div className="signup-launch-screen-whatsapp-section-body">
            <div className="signup-launch-screen-whatsapp-section-body-box primary-font-regular">
              <span className="box-text primary-font-regular">
                Hi ZöTok team, I need help activating my account.
              </span>
            </div>
            <div className="signup-launch-screen-whatsapp-section-body-buttons">
              <ZoButton
                label="Send on WhatsApp"
                onClick={openOnWhatsapp}
                startIcon={<img src={SVGS.WhatsappIcon} alt="" />}
                className="whatsapp-btn"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
